// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__R2Wme","content":"card_content__R4JmG","photoWrap":"card_photoWrap__Nd6YV","photo":"card_photo__0lqTM","text":"card_text__K7BF_"};